document.addEventListener('DOMContentLoaded', function () {
  const btn = document.getElementById('load-more-btn');
  const grid = document.querySelector('.productgrid--items');
  if (!btn || !grid) return;

  const storageKey = 'loadMore_' + location.pathname;

  // rimg画像を強制的に読み込む関数
  function loadRimgImages(container) {
    container.querySelectorAll('img[data-rimg]').forEach(img => {
      const template = img.dataset.rimgTemplate;
      const scale = window.devicePixelRatio || 1;
      if (template) {
        const width = img.closest('li') ? img.closest('li').offsetWidth : 512;
        const px = Math.round(width * scale);
        const size = px + 'x' + px;
        const src = template.replace('{size}', size);
        img.src = src;
        img.srcset = src + ' ' + scale + 'x';
        img.dataset.rimg = 'loaded';
      }
    });
  }

  // 状態を復元する
  function restoreState() {
    const saved = sessionStorage.getItem(storageKey);
    if (!saved) return;

    const { pages, scrollY } = JSON.parse(saved);
    if (!pages || pages.length === 0) return;

    // 保存されたページを順番に取得して復元
    const fetches = pages.map(url => fetch(url).then(r => r.text()));

    Promise.all(fetches).then(htmlList => {
      htmlList.forEach((html, i) => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const newProducts = doc.querySelectorAll('.productgrid--items > *');
        newProducts.forEach(el => {
          grid.appendChild(el);
          requestAnimationFrame(() => loadRimgImages(el));
        });

        // 最後のページのボタンURLを更新
        if (i === htmlList.length - 1) {
          const newBtn = doc.getElementById('load-more-btn');
          if (newBtn) {
            btn.dataset.nextUrl = newBtn.dataset.nextUrl;
          } else {
            document.getElementById('load-more-container').remove();
          }
        }
      });

      // スクロール位置を復元
      requestAnimationFrame(() => {
        window.scrollTo(0, scrollY);
      });
    });
  }

  // ボタンクリック処理
  btn.addEventListener('click', function () {
    const nextUrl = btn.dataset.nextUrl;
    if (!nextUrl) return;

    btn.disabled = true;
    btn.innerHTML = '<span class="load-more-spinner"></span> 読み込み中...';

    fetch(nextUrl)
      .then(res => res.text())
      .then(html => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');

        const newProducts = doc.querySelectorAll('.productgrid--items > *');
        newProducts.forEach(el => {
          el.classList.add('load-more-fade-in');
          grid.appendChild(el);
          requestAnimationFrame(() => {
            loadRimgImages(el);
            requestAnimationFrame(() => {
              el.classList.add('load-more-fade-in--visible');
            });
          });
        });

        const newBtn = doc.getElementById('load-more-btn');
        if (newBtn) {
          btn.dataset.nextUrl = newBtn.dataset.nextUrl;
          btn.innerHTML = 'もっと見る';
          btn.disabled = false;
        } else {
          document.getElementById('load-more-container').remove();
        }

        // 読み込んだページURLを保存
        const saved = sessionStorage.getItem(storageKey);
        const state = saved ? JSON.parse(saved) : { pages: [] };
        state.pages.push(nextUrl);
        state.scrollY = window.scrollY;
        sessionStorage.setItem(storageKey, JSON.stringify(state));
      })
      .catch(err => {
        console.error('Load more failed:', err);
        btn.innerHTML = 'もっと見る（再試行）';
        btn.disabled = false;
      });
  });

  // スクロール位置を随時保存
  window.addEventListener('scroll', function () {
    const saved = sessionStorage.getItem(storageKey);
    if (!saved) return;
    const state = JSON.parse(saved);
    state.scrollY = window.scrollY;
    sessionStorage.setItem(storageKey, JSON.stringify(state));
  });

  // 商品クリック時に状態保存（念のため）
  grid.addEventListener('click', function () {
    const saved = sessionStorage.getItem(storageKey);
    if (!saved) return;
    const state = JSON.parse(saved);
    state.scrollY = window.scrollY;
    sessionStorage.setItem(storageKey, JSON.stringify(state));
  });

  // ページ読み込み時に復元
  restoreState();
});
